export default "__VITE_ASSET__18e1b55f__"